import { Pipe, PipeTransform } from '@angular/core';
import {Country} from '../interface/country.interface';
export class CountryPipe implements PipeTransform {
/**
 * @param {?} value
 * @param {?=} args
 * @return {?}
 */
transform(value: Country[], args?: string): any {
    let /** @type {?} */ searchText = new RegExp(args, 'ig');

    if (value) {
      return value.filter((country: Country) => country.name.search(searchText) !== -1);
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'country'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CountryPipe_tsickle_Closure_declarations() {
/** @type {?} */
CountryPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CountryPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
